export default "__VITE_ASSET__B$C1YlTK__"